<template>
    <tr>
        <td v-if="processed">
            <v-checkbox
                :disabled="!permissions['9'] && permissions['10']"
                @change="onCheckbox"
                dense
                v-model="purchased"
            ></v-checkbox>
        </td>
        <td :class="{'filter-active': filterClasses['trip_id']}">{{ dataVal.trip_id }}</td>
        <td :class="{'filter-active': filterClasses['load_id']}">{{ dataVal['load_id'] }}</td>
        <td :class="{'filter-active': filterClasses['truck']}">{{ dataVal['truck'] }}</td>
        <td :class="[{'filter-active': filterClasses['routs']}]">{{ dataVal['routs'] }}</td>
        <td :class="{'filter-active': filterClasses['broker_number']}">{{ dataVal['broker_number'] }}</td>
        <td :class="{'filter-active': filterClasses['broker_name']}">{{ dataVal['broker_name'] }}</td>
        <td :class="{'filter-active': filterClasses['gross']}">{{ dataVal['gross'] }}</td>
        <td :class="{'filter-active': filterClasses['amount']}">{{ dataVal['amount'] }}</td>
        <td class="icons">
            <v-btn
                v-if="permissions['9'] || !editRow && permissions['8']"
                @click="getViewFiles(dataVal)"
                color="green"
                icon
                fab
                x-small
            >
                <v-icon>visibility</v-icon>
            </v-btn>
        </td>
        <td v-if="isLoads && !processed" class="icons">
            <v-btn
                v-if="permissions['9'] || !editRow && permissions['8']"
                @click="removeCargo(dataVal)"
                color="red"
                icon
                fab
                x-small
            >
                <v-icon>mdi-trash-can</v-icon>
            </v-btn>
        </td>
        <td v-if="!isLoads && !processed" class="icons">
            <v-btn
                v-if="permissions['9'] || !editRow && permissions['8']"
                @click="addCargo(dataVal)"
                color="green"
                icon
                fab
                x-small
            >
                <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
        </td>
    </tr>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "LoadsTr",
	props: {
		dataVal: Object,
		employees: Array,
		filterClasses: Object,
		safetyStatus: Array,
		safetyDrivingHours: Array,
		page: Number,
		index: Number,
		itemsPerPage: [ Number, String ],
		isLoads: Boolean,
		processed: Boolean,
		editRow: Object,
		permissions: Object,
		purchased: Boolean
	},
	computed: {
		getStatusDefault() {
			return this.dataVal['safety_status_id'];
		},
		getHoursDefault() {
			return this.dataVal['driving_hours_id'];
		},
		getEmployeeDefault() {
			return this.dataVal['employee_id'];
		}
	},
	data: () => ({
		filesList: []
	}),
	methods: {
		...mapActions([ 'addSafetyStatus', 'addSafetyHours', 'onUpdateSafetyRow', 'getSchedulesItem' ]),
		onCheckbox() {
			this.dataVal.purchased = this.purchased;
			const values = {
				id: this.dataVal.load_id,
				purchased: this.purchased
			};

			this.$emit('updateCheckbox', values);
		},
		onNotes(value) {
			this.dataVal['notes'] = value;
			this.sentRow();
		},
		async addStatus(value) {
			const values = {
				status: value
			};
			await this.addSafetyStatus(values);
		},
		async addHours(value) {
			const values = {
				hours: value
			};
			await this.addSafetyHours(values);
		},
		async sentRow() {
			const { date, driver_id, safety_status_id, driving_hours_id, notes, employee_id } = this.dataVal;
			const values = {
				date, driver_id, safety_status_id, driving_hours_id, notes, employee_id
			};

			const { status } = await this.onUpdateSafetyRow(values);
			if (status) {
				await this.$store.dispatch("setAlert", {
					type: "success",
					message: "Sending Successful",
				});
			}
		},
		onChangeStatus(value) {
			this.dataVal['safety_status_id'] = value;
			this.sentRow();
		},
		onChangeHours(value) {
			this.dataVal['driving_hours_id'] = value;
			this.sentRow();
		},
		onHandler(id, date, employees) {
			const values = { id, date, employees };
			this.$emit('updateActions', values);
		},
		onChangeNotes() {
			if (this.dataVal['notes']) {
				this.sentRow();
			}
		},
		async getLoadList() {
			const loadFiles = await this.getSchedulesItem(this.dataVal.id);
			this.filesList = loadFiles[0].files;
		},
		getViewFiles({ files }) {
			this.$emit('updateIdView', files);
		},
		onSend() {
			this.$emit('updateSend', this.dataVal.id);
		},
		addCargo({ load_id }) {
			this.$emit('updateCargoId', load_id);
		},
		removeCargo({ load_id }) {
			this.$emit('updateRemoveCargoId', load_id);
		}

	}
};
</script>

<style scoped lang="scss">
.fileList {
    .v-list-item {
        .text {
            font-size: 12px;
            width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.icons {
    button {
        margin-left: 10px;
    }
}

.notesBtn {
    margin-left: 5px;
}

.employees {
    min-width: 150px;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow-x: hidden;
}
.filter-active {
    background-color: rgba(87, 134, 87, 0.3098039216);
}
</style>
